import { render, staticRenderFns } from "./TermsAndCondition.vue?vue&type=template&id=af7e25fa&scoped=true&"
import script from "./TermsAndCondition.vue?vue&type=script&lang=ts&"
export * from "./TermsAndCondition.vue?vue&type=script&lang=ts&"
import style0 from "./TermsAndCondition.vue?vue&type=style&index=0&id=af7e25fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af7e25fa",
  null
  
)

export default component.exports